import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  ButtonProps
} from "@mui/material";
import styles from "./Modal.module.scss";
import CrossIcon from "@/assets/svg/LoginPage/CrossIcon";

interface ModalProps {
  modalOpen: boolean;
  closeModal: () => void;
  heading: string;
  children?: React.ReactNode;
  primaryLabel?: string;
  secondaryLabel?: string;

  primaryButtonProps?: ButtonProps;
  secondaryButtonProps?: ButtonProps;
  maxWidth?: false | "xs" | "sm";
  width?: number;
  crossIcon?: boolean;
  actionBtn?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  modalOpen,
  closeModal,
  heading,
  children,
  primaryLabel = "Save",
  secondaryLabel = "Cancel",
  primaryButtonProps,
  secondaryButtonProps,
  maxWidth = "sm",
  width,
  crossIcon = true,
  actionBtn = false,
}) => {
  return (
    <Dialog
      open={modalOpen}
      onClose={closeModal}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        className: styles.modalPaper,
        style: { width },
      }}
    >
      {/* HEADER */}
      <DialogTitle className={styles.header}>
        <span className={styles.title}>{heading}</span>

        {crossIcon && (
          <CrossIcon onClick={closeModal} className={styles.closeIcon} />
        )}
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent className={styles.content}>{children}</DialogContent>

      {/* ACTIONS */}
      {actionBtn && (
        <DialogActions className={styles.actions}>
          <Button
            variant="text"
            onClick={closeModal}
            {...secondaryButtonProps}
            className={styles.cancelBtn}
          >
            {secondaryLabel}
          </Button>

          <Button
            variant="contained"
            className={styles.primaryBtn}
            disableElevation
            {...primaryButtonProps}
          >
            {primaryButtonProps?.children || primaryLabel}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
